import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import { useProductSet } from './context/ProductSetProvider';
import CatalogCategoryFilter from '../CatalogCategory/CatalogCategoryFilter';
import CatalogAdminDropdown from '../CatalogCategory/CatalogAdminDropdown';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import SolarIcon from 'components/icons/SolarIcon';

interface SetToolBarProps {
    setEditSetId: (setId: number) => void;
    filterCategoryId: number | null;
    setFilterCategoryId: (id: number | null) => void;
}

const SetToolBar = ({ setEditSetId, filterCategoryId, setFilterCategoryId }: SetToolBarProps) => {
    const { t } = useTranslation(['Sets', 'common']);
    const { auth } = useAuth();
    const { triggerListReset, triggerListRefresh } = useProductSet();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                {hasUserAccess(auth?.user, 'prodEdit') && (
                    <Button className="fs-14 ms-1" size="sm" variant="success" onClick={() => setEditSetId(0)}>
                        <SolarIcon name="plus" className="fs-14 p-0" />
                        <span className="ms-1">{t('toolAddSet')}</span>
                    </Button>
                )}

                {!!auth?.user?.admin && <CatalogAdminDropdown kind="set" />}

                <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />

                <CatalogCategoryFilter
                    kind="set"
                    filterCategoryId={filterCategoryId}
                    setFilterCategoryId={setFilterCategoryId}
                />
            </div>
        </div>
    );
};

export default SetToolBar;
